const clean = (value) => String(value ?? "").trim();

const safeReadablePart = (value) => clean(value)
  .replace(/[<>:"/\\|?*]+/g, "-")
  .replace(/\s+/g, " ")
  .replace(/[. ]+$/g, "")
  .trim();

const safeSlug = (value) => safeReadablePart(value)
  .replace(/[^a-z0-9]+/gi, "-")
  .replace(/^-|-$/g, "")
  .toLowerCase();

const MONTH_NAMES = {
  jan: "January",
  feb: "February",
  mar: "March",
  apr: "April",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "August",
  sep: "September",
  oct: "October",
  nov: "November",
  dec: "December",
};

const fullMonthLabel = (value) => {
  const label = clean(value);
  const match = label.match(/^([a-z]+)\s+(\d{4})$/i);
  if (!match) return label;
  const month = MONTH_NAMES[match[1].slice(0, 3).toLowerCase()];
  return month ? `${month} ${match[2]}` : label;
};

export const personalAdviserName = (adviser = {}) => {
  const firstName = clean(adviser.firstName);
  const lastName = clean(adviser.lastName);
  return firstName && lastName ? `${firstName} ${lastName}` : "";
};

export const commissionStatementFileName = ({
  adviser,
  firstName,
  lastName,
  monthLabel,
  extension = "pdf",
}) => {
  const personalName = personalAdviserName({ firstName, lastName });
  const safeExtension = clean(extension).replace(/^\./, "") || "pdf";
  const readableMonthLabel = fullMonthLabel(monthLabel);
  if (personalName) {
    return `${safeReadablePart(personalName)} ${safeReadablePart(readableMonthLabel)}.${safeExtension}`;
  }
  return `${safeSlug(adviser)}-commission-statement-${safeSlug(readableMonthLabel)}.${safeExtension}`;
};
